module.exports = __webpack_public_path__ + "img/bank-18-jeju.8fb9a2e0.svg";